import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { SHIPPING_CONFIG } from '../utils/constants';

const ShippingPolicy = () => {
  return (
    <>
      <Header />
      <div className="page-offset policy-offset">
      <section className="shipping-policy">
        <div className="container">
          <h1 className="h1 section-title">Shipping Policy</h1>
          <div className="shipping-content">
            <p className="shipping-intro">
              <strong>Oracle Gaming</strong> is committed to delivering your trading cards, gaming accessories, and merchandise 
              safely and efficiently across South Africa. This Shipping Policy outlines our delivery methods, timeframes, 
              and procedures to ensure you receive your orders in perfect condition.
            </p>

            <div className="shipping-section">
              <h2 className="h2">Shipping Methods & Providers</h2>
              <p>We partner with <strong>BobGo</strong> courier services to deliver your orders nationwide across South Africa.</p>
              
              <h3 className="h3">Available Shipping Options</h3>
              <div className="shipping-options">
                <div className="shipping-option">
                  <h4>Standard Shipping</h4>
                  <p><strong>Cost:</strong> R{SHIPPING_CONFIG.STANDARD_RATE}</p>
                  <p><strong>Delivery Time:</strong> 3-5 business days</p>
                  <p>Door-to-door courier delivery to your address.</p>
                </div>
                <div className="shipping-option">
                  <h4>PUDO Locker</h4>
                  <p><strong>Cost:</strong> R{SHIPPING_CONFIG.PUDO_RATE}</p>
                  <p><strong>Delivery Time:</strong> 3-5 business days</p>
                  <p>Collect your order from a PUDO locker at a time that suits you.</p>
                </div>
                <div className="shipping-option">
                  <h4>Collect from Store</h4>
                  <p><strong>Cost:</strong> Free</p>
                  <p><strong>Collection Time:</strong> 1-2 business days</p>
                  <p>Pick your order up from us in Bloemfontein at no charge.</p>
                </div>
              </div>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Free Shipping</h2>
              <p>
                <strong>Free shipping is available on all orders over R{SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD.toLocaleString()}!</strong>{' '}
                This applies to both Standard Shipping and PUDO Locker delivery.
                Simply add items to your cart totaling R{SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD.toLocaleString()} or more
                and select your preferred delivery method at no additional cost.
              </p>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Delivery Areas</h2>
              <p>We deliver nationwide across South Africa, including:</p>
              <ul>
                <li>All major cities and metropolitan areas</li>
                <li>Suburban and rural areas</li>
                <li>Remote locations (delivery times may vary)</li>
              </ul>
              <p><strong>Note:</strong> We currently do not offer international shipping.</p>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Order Processing</h2>
              <p>Once you place your order:</p>
              <ul>
                <li><strong>Processing Time:</strong> Orders are processed within 1 business day</li>
                <li><strong>Shipping Days:</strong> We ship Monday to Friday (excluding weekends)</li>
                <li><strong>Holiday Periods:</strong> We do not ship during public holidays</li>
                <li><strong>Peak Periods:</strong> During busy periods (like new product releases), processing may take slightly longer</li>
              </ul>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Special Packaging & Protection</h2>
              <p>Your valuable trading cards and gaming items are protected with:</p>
              <ul>
                <li><strong>Card Protection:</strong> Specialized packaging to prevent bending and damage</li>
                <li><strong>Insured Delivery:</strong> All shipments are fully insured through our courier partner</li>
                <li><strong>Secure Packaging:</strong> Bubble wrap, protective sleeves, and sturdy boxes</li>
                <li><strong>Limited Editions:</strong> Extra protection for rare and valuable items</li>
              </ul>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Tracking & Notifications</h2>
              <p>Stay informed about your order:</p>
              <ul>
                <li><strong>Tracking Numbers:</strong> You'll receive a tracking number once your order ships</li>
                <li><strong>Email Notifications:</strong> Shipping confirmations and delivery updates via email</li>
                <li><strong>SMS Updates:</strong> Real-time delivery notifications via SMS</li>
                <li><strong>Online Tracking:</strong> Track your package through BobGo's online system</li>
              </ul>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Damaged or Lost Items</h2>
              <p>In the rare event of shipping issues:</p>
              <ul>
                <li><strong>Insured Deliveries:</strong> All shipments are covered by courier insurance</li>
                <li><strong>Damage Assessment:</strong> Damaged items will be assessed by our team</li>
                <li><strong>Resolution Options:</strong> We'll provide either a full refund or send a replacement product</li>
                <li><strong>Lost Packages:</strong> Lost items are covered by courier insurance and will be replaced or refunded</li>
              </ul>
              <p>
                <strong>Important:</strong> Please inspect your package upon delivery and report any issues immediately.
              </p>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Returns & Exchanges</h2>
              <p>For returns and exchanges:</p>
              <ul>
                <li><strong>Collection Service:</strong> Returns are handled through courier collection</li>
                <li><strong>No Return Shipping Cost:</strong> We cover the cost of return shipping</li>
                <li><strong>Easy Process:</strong> Contact us to arrange collection of unwanted items</li>
                <li><strong>Quick Processing:</strong> Returns are processed within 2-3 business days</li>
              </ul>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Pre-Orders & Special Items</h2>
              <p>For pre-orders and special releases:</p>
              <ul>
                <li><strong>Pre-Order Shipping:</strong> Items ship as soon as they arrive in stock</li>
                <li><strong>Special Packaging:</strong> Limited edition items receive extra protection</li>
                <li><strong>Priority Processing:</strong> Pre-orders are processed with priority</li>
                <li><strong>Release Day Delivery:</strong> We aim to deliver on or before release dates</li>
              </ul>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Contact Information</h2>
              <p>For shipping inquiries or issues, please contact us:</p>
              <div className="contact-info">
                <p><strong>Phone:</strong> <a href="tel:0825655408">082 565 5408</a></p>
                <p><strong>Email:</strong> <a href="mailto:oraclegaming.za@gmail.com">oraclegaming.za@gmail.com</a></p>
                <p><strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM</p>
              </div>
            </div>

            <div className="shipping-section">
              <h2 className="h2">Important Notes</h2>
              <ul>
                <li>Delivery times are estimates and may vary due to weather, traffic, or other factors</li>
                <li>Someone must be available to receive the package at the delivery address</li>
                <li>If no one is available, the courier will attempt delivery again or leave a collection notice</li>
                <li>We are not responsible for delays caused by incorrect or incomplete address information</li>
                <li>All shipping costs are calculated at checkout and are non-refundable unless the order is cancelled before shipping</li>
              </ul>
            </div>

            <div className="shipping-footer">
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              <p>This shipping policy is subject to change. Please check back regularly for updates.</p>
            </div>
          </div>
        </div>
      </section>
      </div>
      <Footer />
    </>
  );
};

export default ShippingPolicy;
